import { render, staticRenderFns } from "./ContentTypesComboMulti.vue?vue&type=template&id=2b5bf32a&scoped=true&"
import script from "./ContentTypesComboMulti.vue?vue&type=script&lang=js&"
export * from "./ContentTypesComboMulti.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypesComboMulti.vue?vue&type=style&index=0&id=2b5bf32a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5bf32a",
  null
  
)

export default component.exports